// extracted by mini-css-extract-plugin
export default {"list":"uvT2y7MKPPN4ctLaQ7Kq","title":"Dt2XoN6Dc9DJsiGXQNiK","body":"OXh71tnCd72kwsvf7hxV"};